jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});


    document.addEventListener('DOMContentLoaded', function() {
      const discountContainer = document.querySelector('.discount-container');
      const notification = document.getElementById('copy-notification');

      if (discountContainer) {
        discountContainer.addEventListener('click', async function() {
          const codeElement = document.querySelector('.dashed-dis');
          
          if (codeElement) {
            try {
              await navigator.clipboard.writeText(codeElement.textContent.trim());
              
              // Show notification
              notification.classList.add('show');
              
              // Hide notification after 2 seconds
              setTimeout(() => {
                notification.classList.remove('show');
              }, 2000);
            } catch (err) {
              console.error('Failed to copy text: ', err);
            }
          }
        });
      }
    });









